var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],ref:"loadingPic",staticClass:"loading",attrs:{"src":require("@/assets/images/paw.gif"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }